import { Injectable } from '@angular/core'
import { Headers, Http, RequestOptions, Response } from '@angular/http'
import { Observable } from 'rxjs/Rx'

import 'rxjs/add/operator/toPromise'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'

import { TransformacionService } from './transformacion.service'
import { PreguntaPrimerNivel } from '../dominio/pregunta-primer-nivel'
import { RespuestaPrimerNivel } from '../dominio/respuesta-primer-nivel'
import { Declaracion } from '../dominio/declaracion'
import { Conclusion } from 'app/dominio/conclusion'
import { groupBy } from 'rxjs/operator/groupBy'
import { Decision, Tipo } from 'app/dominio/decision'
import { environment } from 'environments/environment'
import { timeout } from 'rxjs/operator/timeout'

@Injectable()
export class DeclaracionService {

  private urlBase: string = environment.host
  private urlDeclaraciones: string = `${this.urlBase}/declaraciones`
  private urlDeclaracionesLegadas: String = `${this.urlDeclaraciones}/legadas`
  private urlEvaluarDeclaracion: string = `${this.urlDeclaraciones}/evaluar`
  private headers = new Headers({'Content-Type': 'application/json'})

  constructor (private http: Http, private transformacion: TransformacionService) {}

  obtenerDeclaracion(idSolicitud: string, dni: string): Observable<Declaracion> {
    return this.http
      .get(`${this.urlDeclaracionesLegadas}?idSolicitud=${idSolicitud}&dni=${dni}`, { withCredentials: true })
      .map(res => res.json())
      .switchMap(data => this.asignarNombreOcupacion(data))
      .catch(this.manejarError)
  }

  asignarNombreOcupacion(json: any) {
    const p = json.data.relationships.prospecto.data.attributes
    return this.http
    .get(this.urlBase+"/ocupaciones?codigo=" + p.ocupacion.nombre, { withCredentials: true })
    .map(res => res.json().nombre)
    .map(nombre => this.transformarRespuesta(json, nombre))
    .catch(this.manejarError)    
  }

  enviarDeclaracion(declaracion: Declaracion) {
    const jsonDcl = JSON.stringify(declaracion.toJson())
    const headers = new Headers({ 'Content-Type': 'application/json' })
    const options = new RequestOptions({ headers: headers, withCredentials: true})
    return this.http
      .post(this.urlEvaluarDeclaracion, jsonDcl, options)
      .toPromise()
      .then(res => this.transformacion.transformarConclusionesRespuestas(res.json()))
      .catch(this.manejarError)
  }

  verificarPreguntas(preguntas: PreguntaPrimerNivel[]) {
    type respuestaVerificar = { idPreguntaPrimerNivel: String, idRespuestaPrimerNivel: String, idPreguntaSecundaria: String}
    const pv = preguntas.reduceRight<respuestaVerificar[]>((acum, actual) => {
      actual.respuestas.forEach( respuesta => {
        if (respuesta.autocompletarVacio) {
          acum.push({ idPreguntaPrimerNivel: actual.id, idRespuestaPrimerNivel: respuesta.id, idPreguntaSecundaria: ''})
        }
        respuesta.preguntasSecundarias.forEach( preguntaSecundaria => {
          if (preguntaSecundaria.respuestaSeleccionada === '') {
            acum.push({ idPreguntaPrimerNivel: actual.id, idRespuestaPrimerNivel: respuesta.id, idPreguntaSecundaria: preguntaSecundaria.id})
          }
        })
      })
      return acum
    }, [])
    if (pv.length > 0) {
      dispatchEvent(new CustomEvent('verificarPreguntas', { detail: { paths: pv }}))
      return false
    }
    return true
  }

  private transformarRespuesta(json: any, nomOcupacion: string): Declaracion {
    return this.transformacion.transformarJsonapiADeclaracion(json, nomOcupacion)
  }

  private manejarError (error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body.error || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    console.error(`error: ${errMsg}`)
    return Observable.throw(errMsg)
  }
}



// WEBPACK FOOTER //
// ./src/app/servicios/declaracion.service.ts